<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :class="modalClass"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增关键词</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign="campaign"
            :group="group"
            group-select
            @input-group-option="inputGroupOption"
        ></app-base-info>
        <app-keyword-picker
            ref="picker"
            bid-input
            show-suggested-bidding
            :market-id="marketId"
            :formBase="form.baseInfoForm"
            :form="form.keywordPickerForm"
            title="关键词"
            width="535px"
            :matchTypeOption="matchTypeOption"
            bidLabelWidth="119px"
            :ad-suggest-keyword$="adSuggestKeyword$"
        ></app-keyword-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import AppBaseInfo from "../common/base-info";
  import AppKeywordPicker from "../common/keyword-picker";
  import {AdGroupEnum, AdKeywordEnum} from "modules/ad/common/enum";
  import {isMeaningful} from "@/utils/common";
  import {isMeaningfulMixin, modalMixIn} from "@/minxins";
  import {rankRecommendation, SP} from "@/api/ad";

  export default {
    name: "app-add-sp-ad-keyword",
    mixins: [modalMixIn, isMeaningfulMixin],
    components: {AppKeywordPicker, AppBaseInfo},
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SP.targetingType.KEYWORD,
            campaignId: this.campaign?.campaignId || null,
            groupId: this.group?.groupId || null,
          },
          keywordPickerForm: {
            items: [],
            inputMatchTypes: [
              AdKeywordEnum.SP.matchType.EXACT
            ],
            matchTypes: [
              AdKeywordEnum.SP.matchType.EXACT,
              AdKeywordEnum.SP.matchType.PHASE,
              AdKeywordEnum.SP.matchType.BROAD
            ],
            bid: null,
          }
        },
        AdKeywordEnum: AdKeywordEnum,
        adSuggestKeyword$: null
      }
    },
    watch: {
      group: {
        handler: function(group) {
          if (this.isMeaningful(group)) {
            this.$nextTick(() => {
              this.inputGroupOption({
                id: group.groupId,
                bid: group.bid
              });
            });
          }
        },
        immediate: true
      }
    },
    computed: {
      modalClass() {
        if (this.isMeaningful(this.group)) {
          return 'gj-modal_1220X677';
        } else {
          return 'gj-modal_1220X719';
        }
      },
      matchTypeOption() {
        return AdKeywordEnum.SP.matchTypeOption.slice(0, 3)
      }
    },
    methods: {
      inputGroupOption(option) {
        if (isMeaningful(option)) {
          if (isMeaningful(this.$refs['picker'])) {
            this.$refs['picker'].suggestKeywordLoading = true;
          }
          // 商品广告 -- 广告活动、广告组、关键词 -- 新建弹框 -- 获取建议关键词列表
          this.adSuggestKeyword$ = {
            getData:rankRecommendation,
            params:{
              marketId: this.marketId,
              campaignId:this.form.baseInfoForm.campaignId,
              groupId: option.id,
            }
          };
          this.form.keywordPickerForm.bid = option.bid;
        }
      },
      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'picker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid])
          .then(() => this.keywordsAdd())
          .catch((error) => console.log('zs', error))
          .complete(() => this.confirmLoading = false)
      },
      keywordsAdd() {
          this.confirmLoading = true;
          const params = {
            marketId: this.marketId,
            params: this.form.keywordPickerForm.items.map(e => ({
              campaignId: this.form.baseInfoForm.campaignId,
              groupId: this.form.baseInfoForm.groupId,
              keywordText: e.keyword,
              bid: e.bid,
              matchType: e.matchType,
            })),
          };
          SP.keywordsAdd(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
